import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { Modal, Progressbar } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";
import { BackButton, CloseButton } from "../DialogNavigationButtons";
import { PropertySelectStep } from "./steps/PropertySelectStep";
import { UploadForestandStep } from "./steps/UploadForestandStep";
import { ForestRequirementStep } from "./steps/ForestRequirementStep";
import { CarbonConfirmationStep } from "./steps/CarbonConfirmationStep";
import { PropertyFailedCriteriaStep } from "./steps/PropertyFailedCriteriaStep";
import { ErrorModal } from "../../../../modals";
import { apiFetch } from "../../../../api/client";
import { UploadPdfStep } from "./steps/UploadPdfStep";
import { CarbonValueStep } from "./steps/CarbonValueStep";
import { useModalCloseOnEsc } from "../../utils";

export default function ArbonicsDialog({ visible, hide, initialStepIndex = 0 }) {
  const [currentStepIndex, setCurrentStepIndex] = useState(initialStepIndex);
  const [arbonicsData, setArbonicsData] = useState({});
  const [co2ID, setCo2ID] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [updateCo2Fired, setUpdateCo2Fired] = useState(false)

  useEffect(() => {
    if (initialStepIndex !== undefined && initialStepIndex >= 0) {
      setCurrentStepIndex(initialStepIndex);
    }
  }, [initialStepIndex]);

  const GetConfirmOrFailStep = (obj) => {
    if (arbonicsData.sbo?.arbonics?.eligible == 2 || arbonicsData.sbo?.data?.arbonics?.eligible == 2) {
      return ForestRequirementStep(obj)
    } 
    return PropertyFailedCriteriaStep(obj)
  }

  const steps = [
    PropertySelectStep,
    CarbonValueStep,
    UploadForestandStep,
    UploadPdfStep,
    GetConfirmOrFailStep,
    CarbonConfirmationStep,
  ]

  const stepNames = [
    "property_selection",
    "carbon_value_step",
    "upload_forestand",
    "upload_pdf",
    "get_confirmation_or_fail_step",
    "carbon_confirmation_step",
  ];

  const totalSteps = steps.length;

  const clearData = () => {
    setCurrentStepIndex(0);
    setArbonicsData({});
    setCo2ID(null);
  };

  const handleClose = () => {
    clearData();
    hide();
  };

  const handleBack = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const createCo2Deal = async (desi, ref) => {
    const data = {
      description_of_property: desi,
      ref: ref ?? null,
      message: "Not sent, only finished step 1"
    }

    const resp = await apiFetch("/create-co2/", {
      method: 'POST',
      body: JSON.stringify({ "data": data }),
    })

    if (resp.status == 200) {
      let json = resp.data
      setCo2ID(json.id)

    } else {
      const message =
        typeof resp.data === "string"
          ? resp.data
          : "Något gick fel. Försök igen senare."
      setErrorModal({ title: "Kan inte ansöka om kolkrediter", message })
    }

    return resp.data
  }

  const updateCo2Deal = async (data, contentType = 'application/json') => {
    setUpdateCo2Fired(true)
    let headers = {
      'X-CSRFToken': Cookies.get('csrftoken')
    }

    if (contentType) {
      headers['Content-Type'] = contentType
      data = JSON.stringify(data)
    }

    const resp = await apiFetch("/update-co2/" + co2ID + "/", {
      method: 'POST',
      headers: headers,
      body: data
    })

    if (resp.status < 200 || resp.status > 299) {
      if (!errorModal) {
        setErrorModal(true)
      }
    }
    return resp.data;
  }

  const handleNext = ({ data, stepsToSkip = 1 }) => {

    mixpanel.track('fe_co2_step_viewed', {
      step: stepNames[currentStepIndex],
      step_index: currentStepIndex
    })
    gtag("event", "fe_co2_step_viewed_" + currentStepIndex.toString(), {
      method: "site"
    });


    setArbonicsData((prev) => ({ ...prev, ...data }));

    if (currentStepIndex === steps.length - 1) {
      clearData();
      hide();
      return;
    }

    const nextStepIndex = currentStepIndex + stepsToSkip;
    setCurrentStepIndex(nextStepIndex);
  }

  useModalCloseOnEsc(visible, handleClose);

  const StepComponent = steps[currentStepIndex];
  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStepIndex === totalSteps - 1;

  return (
    <>
      <TailwindWrapper>
        <Modal isOpen={visible} borderless>
          <Modal.Header>
            {!isFirstStep && <BackButton handleBack={handleBack} hide={isLastStep} />}
            <Progressbar steps={steps.length} activeStep={currentStepIndex} />
            <CloseButton handleClose={handleClose} />
          </Modal.Header>
          <StepComponent
            currentStepIndex={currentStepIndex}
            totalSteps={totalSteps}
            updateCo2Deal={updateCo2Deal}
            createCo2Deal={createCo2Deal}
            handleBack={handleBack}
            handleNext={handleNext}
            handleClose={handleClose}
            arbonicsData={arbonicsData}
            updateCo2Fired = {updateCo2Fired}
          />
        </Modal>
      </TailwindWrapper>
      <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
    </>
  );

}